import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import QuestionnaireContext from '../../../../context/questionnaire-context';
import CustomerContext from '../../../../context/customer-context';
import styles from './QuestionnaireView.module.css';
import { convertDate, convertDateTime, getQuestionnaireName } from './util';
import { Answer } from '../../../../models/QuestionnaireAnswer';
import BreadCrumbs from '../../../common/BreadCrumbs/BreadCrumbs';

function QuestionnaireView() {
  const questionnaireCtx = useContext(QuestionnaireContext);
  const customerCtx = useContext(CustomerContext);
  const { t } = useTranslation();


  const getAnswerValue = (answer: Answer[]) => {
    if (answer.length > 1) {
      return (
        <td>
          {answer.filter(item => item.value !== '').map(value => value.value).join(', ')}
        </td>
      );
    }

    return <td>{answer[0].value}</td>;
  };

  const isAnswerPresent = (answer: Answer[]) => answer.filter(item => item.value !== '').length > 0;

  return (
    <>
    <BreadCrumbs />
    <div className={styles.pageTitle}>
      {getQuestionnaireName(questionnaireCtx.questionnaire.questionnaireType)}
    </div>
    <div className={styles.container}>
      <div className={styles.clientInfo}>
        <div className={styles.infoRow}>
          <div className={styles.label}>
            {t('customer.dashboard.serviceInformation.questionnaireView.clientName')}:
          </div>
          <div>
            {customerCtx.customer.firstName}
            {' '}
            {customerCtx.customer.name}
          </div>
        </div>
        <div className={styles.infoRow}>
          <div className={styles.label}>
            {t('customer.dashboard.serviceInformation.questionnaireTable.header.filled')}:
          </div>
          <div>{convertDateTime(questionnaireCtx.questionnaire.createTimestamp)}</div>
        </div>
        <div className={styles.infoRow}>
          <div className={styles.label}>
            {t('customer.dashboard.serviceInformation.questionnaireTable.header.expires')}:
          </div>
          <div>{convertDate(questionnaireCtx.questionnaire.expirationDate)}</div>
        </div>
      </div>
      <table className={styles.table}>
        <thead>
        <tr className={styles.row}>
          <th>
            {t(
              'customer.dashboard.serviceInformation.questionnaireView.answersTable.header.question'
            )}
          </th>
          <th>
            {t(
              'customer.dashboard.serviceInformation.questionnaireView.answersTable.header.answer',
            )}
          </th>
        </tr>
        </thead>
        <tbody>
        {questionnaireCtx.questionnaire.answers && questionnaireCtx.questionnaire.answers.map(
          answer => {
            if (isAnswerPresent(answer.values)) {
              return (
                <tr key={uuid()} className={styles.row}>
                  <td>{answer.admin_label || answer.label}</td>
                  {getAnswerValue(answer.values)}
                </tr>
              );
            }
          },
        )}
        </tbody>
      </table>
    </div>
    </>
  );
}

export default QuestionnaireView;
